import React from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-list-item");
/**
 * This component us used to create the one to three lines of text within a
 * `ListItem` or `SimpleListItem`.
 */
export function ListItemText(_a) {
    var className = _a.className, secondaryTextClassName = _a.secondaryTextClassName, secondaryText = _a.secondaryText, children = _a.children;
    var secondaryContent;
    if (secondaryText) {
        secondaryContent = (React.createElement("span", { className: cn(block("text", { secondary: true }), secondaryTextClassName) }, secondaryText));
    }
    return (React.createElement("span", { className: cn(block("text"), className) },
        children,
        secondaryContent));
}
/* istanbul ignore next */
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        ListItemText.propTypes = {
            className: PropTypes.string,
            secondaryTextClassName: PropTypes.string,
            secondaryText: PropTypes.node,
            children: PropTypes.node,
        };
    }
    catch (e) { }
}
//# sourceMappingURL=ListItemText.js.map